import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesAction,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import Url from "../../apiCall/UrlConfig";
//////Redux

import jwt from "jwt-decode";
import { useEffect } from "react";
import { toEnglishDigits } from "../../component/utility";
const InputForm = (props) => {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const rightInputColor = "#c7554a";
  const leftInputColor = "#de3928";

  const _onClickEnter = async (e) => {
    let values = form.getFieldsValue();

    values.username = toEnglishDigits(values.username);
    values.password = toEnglishDigits(values.password);

    let url = Url.login;
    let res = await props.actions.CallCoreServicesAction(url, values);

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let token = res?.data;
    console.log("token", token);
    localStorage.setItem("@token", token);

    await props.actions.OfflineCoreServices("token", "jwt", token);
    handleToken(token);
  };

  const _onEnterStudent = async (token) => {
    let url = Url.isExamAccepted;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    if (res?.data?.isAcceptedExam) {
      navigate("/dentistLabeling");
    } else {
      if (res?.data?.isSawDemo) {
        navigate("/examStudent");
      } else {
        navigate("/demo");
      }
    }
    console.log(res?.data);
  };
  const handleToken = (token) => {
    let decoded_token = jwt(token);
    // console.log(decoded_token);
    let roll =
      decoded_token[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];

    if (roll == "admin") {
      navigate("/profile/adminprofilepage");
      return;
    }

    if (roll == "student") {
      _onEnterStudent(token);
      return;
    }
    if (roll == "professor") {
      navigate("/professorprofile");
      return;
    }

    if (roll == "lateralanalyse") {
      navigate("/lateralchephalo/main");
      return;
    }
    if (roll == "opganalyses") {
      navigate("/opganalyse/mainpage");
      return;
    }
    if (roll == "numberingteeth") {
      navigate("/numberteeth/mainpage");
      return;
    }
    if (roll == "implant") {
      navigate("/implant");
      return;
    }
    if (roll == "cephaloadmin") {
      navigate("/lateralchephalo/main");
      return;
    }
    if (roll == "segmentcaries") {
      navigate("/segmentcaries/main");
      return;
    }

    if (roll == "profileanalysis") {
      navigate("/ProfileAnalysis");
      return;
    }

    if (roll == "opgnumbering") {
      navigate("/opgnumbering/mainpage");
      return;
    }
    if (roll == "periapicallesion") {
      navigate("/periapicallesion/mainpage");
      return;
    }
    if (roll == "cbctai") {
      navigate("/cbctai/mainpage");
      return;
    }

    message.success(roll);
  };

  useEffect(() => {
    _baseontokeninRedux();
  }, []);

  const _baseontokeninRedux = () => {
    let token = props.coreData["token"]?.jwt?.data;
    if (token != null) {
      handleToken(token);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff00",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Divider style={{ width: 50, zIndex: 1 }}>اطلاعات ورود</Divider>
      <Form form={form}>
        <Form.Item name="username">
          <div>
            <div
              style={{
                position: "absolute",
                right: -50,
                width: 100,
                height: "100%",
                backgroundColor: rightInputColor,
                borderRadius: 15,
                display: "flex",
                alignItems: "center",
                paddingRight: 20,
              }}
            >
              <UserOutlined style={{ color: "white" }} />
            </div>
            <Input
              placeholder="نام کاربری"
              style={{ borderRadius: 20, textAlign: "center" }}
              //   onChange={(e) => setUsername(e.target.value)}
              //   value={username}
              // addonAfter={<span>sss</span>}
            />
          </div>
        </Form.Item>
        <Form.Item name="password">
          <div>
            <div
              style={{
                position: "absolute",
                right: -50,
                width: 100,
                height: "100%",
                backgroundColor: rightInputColor,
                borderRadius: 15,
                display: "flex",
                alignItems: "center",
                paddingRight: 20,
              }}
            >
              <LockOutlined style={{ color: "white" }} />
            </div>
            <Input.Password
              placeholder="رمز ورود"
              style={{ borderRadius: 20, textAlign: "center" }}
              //   onChange={(e) => setPassword(e.target.value)}
              //   value={password}
              // addonAfter={<span>sss</span>}
            />
          </div>
        </Form.Item>

        <div style={{}}>
          <Form.Item>
            <div>
              <div
                style={{
                  position: "absolute",
                  right: -50,
                  width: 100,
                  height: "100%",
                  backgroundColor: rightInputColor,
                  borderRadius: 15,
                }}
              ></div>
              <Button
                onClick={_onClickEnter}
                style={{ borderRadius: 15, width: 150, zIndex: 10 }}
                loading={props?.coreData[Url.login]?.[Url.action]?.isFetching}
              >
                <strong> ورود</strong>
              </Button>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: 200,
                  height: "100%",
                  backgroundColor: leftInputColor,
                  borderRadius: 15,
                  display: "flex",

                  paddingLeft: 20,
                }}
              ></div>
            </div>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

const Profile = (props) => {
  return (
    <div>
      <InputForm {...props} />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  {
    CallCoreServicesAction,
    OfflineCoreServices,
    CallCoreServicesActionWithToken,
  },
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
